import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import awaitMandarkQueries from 'lib/hocs/awaitMandarkQueries';
import {resource} from '@albert-io/json-api-framework/request/builder';
import {Link} from 'react-router';
import {Modal, Dialogue, Heading, Text, Button, SelectField} from '@albert-io/atomic';
import './create-assignment-modal.scss';

export const CreateAssignmentModal = ({handleClose, subjects}) => {
  const [selectedSubject, setSelectedSubject] = useState();
  useEffect(() => {
    setSelectedSubject(subjects.first().getUrlSlug());
  }, [subjects]);
  return (
    <Modal handleClose={handleClose} ariaLabel='Create Assignment'>
      {({modalContentStyle}) => {
        return (
          <Dialogue
            inModal
            className={modalContentStyle}
            title='Create Assignment'
            handleClose={handleClose}
          >
            <Dialogue.Body>
              <Text emphasis='lowest' as='p'>
                Choose one of the options below to create an assignment.
              </Text>
              <fieldset className='u-mar-b_3 create-assignent-modal__fieldset'>
                <legend size='s' className='create-assignent-modal__fieldset-legend'>
                  Option 1
                </legend>
                <Heading size='s' className='u-mar-b_2'>
                  Create from a Practice Guide
                </Heading>
                <SelectField
                  className='u-mar-b_2'
                  border
                  label='Select Subject'
                  options={subjects.map((subject) => ({
                    label: subject.getName(),
                    value: subject.getUrlSlug()
                  }))}
                  onChange={(e) => {
                    setSelectedSubject(e.target.value);
                  }}
                />
                <Button className='u-mar-b_2 u-width_100pc' as={Link} to={`/${selectedSubject}`}>
                  Go to Practice Guide
                </Button>
              </fieldset>
              <fieldset className='create-assignent-modal__fieldset'>
                <legend size='s' className='create-assignent-modal__fieldset-legend'>
                  Option 2
                </legend>
                <Heading size='s' className='u-mar-b_2'>
                  Create from a Folder
                </Heading>
                <Button className='u-mar-b_2 u-width_100pc' as={Link} to='/saved'>
                  Go to Folders
                </Button>
              </fieldset>
            </Dialogue.Body>
          </Dialogue>
        );
      }}
    </Modal>
  );
};

export default awaitMandarkQueries(
  ({classroomId}) => ({
    queries: {
      subjects: resource('subjects_v2')
        .mandarkEndpoint(['classrooms_v1', classroomId, 'subjects_v2'])
        .include('guides_v1')
        .sort('name')
        .pageSize('infinite')
        .filter({
          guides_v1: {
            guide_type: 'practice'
          }
        })
    },
    loadingElement: null
  }),
  CreateAssignmentModal
);

CreateAssignmentModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  subjects: PropTypes.any
};
